import React from 'react';
import classNames from 'classnames';

import css from './IconReviewStar.module.css';

/**
 * Review star icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {boolean?} props.isFilled is filled with color
 * @returns {JSX.Element} SVG icon
 */
const IconReviewStar = props => {
  const { className, rootClassName, isFilled } = props;
  const filledOrDefault = isFilled ? css.filled : css.root;
  const classes = classNames(rootClassName || filledOrDefault, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        fill="#211737"
        d="M11.333 23.027 16 19.472l4.667 3.553-1.744-5.778 4.641-3.288h-5.687L16 7.897l-1.877 6.062H8.436l4.64 3.288zM16.004 28q-2.488 0-4.68-.944a12.1 12.1 0 0 1-3.812-2.565 12.1 12.1 0 0 1-2.567-3.808Q4 18.494 4 16.004t.945-4.68a12.1 12.1 0 0 1 2.562-3.812 12.1 12.1 0 0 1 3.809-2.567A11.7 11.7 0 0 1 15.996 4q2.488 0 4.68.945a12.1 12.1 0 0 1 3.812 2.563 12.1 12.1 0 0 1 2.567 3.81q.945 2.19.945 4.678t-.944 4.68a12.1 12.1 0 0 1-2.565 3.812 12.2 12.2 0 0 1-3.808 2.567Q18.496 28 16.004 28"
      ></path>
    </svg>
  );
};

export default IconReviewStar;
